import React, { useRef, useState } from "react";
import Youtube from "react-youtube";
import styled from "styled-components";

interface IIframe {
  src: string;
  frameBorder?: string;
}

const StyledYoutube = styled(Youtube)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
  cursor: pointer;
`;

const Poster = styled.img`
  position: absolute;
  object-fit: cover;
  height: 100%;
  top: 0;

  &.hide {
    display: none;
  }
`;

const opts = {
  width: undefined,
  height: undefined,
};

interface IProps {
  videoId: string;
  poster?: { url?: string; alt?: string };
}

const YoutubePlayer = ({ videoId, poster }: IProps): JSX.Element => {
  // tslint:disable-next-line: no-any
  const player = useRef<any>(null);
  const [posterClicked, setPosterClicked] = useState<boolean>(false);
  const [playerReady, setPlayerReady] = useState<boolean>(false);

  const onReady = (e: Event): void => setPlayerReady(true);

  const playVideo = (): void => {
    if (playerReady) {
      player.current.internalPlayer.playVideo();

      setPosterClicked(true);
    }
  };

  if (poster) {
    return (
      <>
        <StyledYoutube
          videoId={videoId}
          opts={opts}
          ref={player}
          onReady={onReady}
        />
        {!posterClicked && (
          <Poster src={poster.url} alt={poster.alt} onClick={playVideo} />
        )}
      </>
    );
  }

  return <StyledYoutube videoId={videoId} opts={opts} ref={player} />;
};

export default YoutubePlayer;
